import React from "react";
import moment from "moment";
import ReCAPTCHA from "react-google-recaptcha";
import {
  message,
  Form,
  Icon,
  Input,
  Button,
  Row,
  Col,
  DatePicker,
  Divider,
  Spin,
  Select,
} from "antd";
import dialog from "../../common/utility/dialog";
import global from "../../common/utility/global";
import {
  FORMAT_2DECIMALS,
  FORMAT_EMAIL,
} from "../../common/types/regularExpresionType";
import portalService from "../../service/integracion/portalService";
import "./styles.css";
const { Option } = Select;
class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      tiposComprobante: [
        { id: 2, nombre: "FACTURA" },
        { id: 4, nombre: "BOLETA" },
        { id: 8, nombre: "NOTA DE CRÉDITO" },
        { id: 9, nombre: "NOTA DE DÉBITO" },
        { id: 10, nombre: "GUÍA DE REMISIÓN - REMITENTE" },
        { id: 32, nombre: "GUÍA DE REMISIÓN - TRANSPORTISTA" },

      ],
      rucEmisor: "",
      idTipoComprobante: 0,
      serie: "",
      numero: "",
      fechaStr: global.fetchCurrentDateStr(),
      total: "",
      correo: "",
      recaptchaRef: React.createRef(),
    };
  }

  onChange = async (property, value, form) => {
    this.setState({
      formValues: { ...this.state.formValues, almacenLoading: true },
    });
  };

  complete2Decimals = (e) => {
    if (e.target.value === "" || isNaN(parseFloat(e.target.value).toFixed(2)))
      this.props.form.setFieldsValue({ total: "0.00" });
    else
      this.props.form.setFieldsValue({
        total: parseFloat(e.target.value).toFixed(2),
      });
  };

  correoCustomValidation = (rule, value, callback) => {

    var regexp = new RegExp(FORMAT_EMAIL);
    if (!regexp.test(value)) callback("Formato de correo invalido.");

    callback();
  };

  handleEnviarCorreo = (e) => {
    e.preventDefault();
    this.props.form.setFieldsValue({ validarCorreo: true}, () => {
      // this.props.form.validateFields("correo");
      var recaptchaValue = this.state.recaptchaRef.current.getValue();
      if (recaptchaValue === "") {
        message.error("Confirmación de captcha incorrecta.");
        return;
      }
      this.props.form.validateFieldsAndScroll(async (err, values) => {
        
        if (!err) {
          this.setState({
            loading: true,
          });
          const form = {
            rucEmisor: values.rucEmisor,
            idTipoComprobante:
              values.idTipoComprobante === undefined
                ? 0
                : values.idTipoComprobante.key,
            serie: values.serie,
            numero: values.numero,
            fechaStr: values.fechaStr.format("DD/MM/YYYY"),
            total: values.total,
            correo: values.correo,
          };
          
          var response = await portalService.enviarCorreoPortal(form);
  
          this.setState({
            loading: false,
          });

          if(response===undefined) {
            message.warning("Verifique los datos del comprobante.");
            return;
          }

          if (response.status === 200) {
            message.success("Correo enviado correctamente.");
            return;
          }
  
          if (response.status === 400) {
            dialog.warning(
              <ul>
                {response.data.messages.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            );
            return;
          }
  
          dialog.error(
            "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
          );
        }
      });
    });
  };

  handleDescargarXML = (e) => {
    e.preventDefault();
    this.props.form.setFieldsValue({ validarCorreo: false}, () => {
      
      // this.props.form.validateFields("correo");
      var recaptchaValue = this.state.recaptchaRef.current.getValue();
      if (recaptchaValue === "") {
        message.error("Confirmación de captcha incorrecta.");
        return;
      }
      this.props.form.validateFieldsAndScroll(async (err, values) => {
        
        if (!err) {
          this.setState({
            loading: true,
          });
          const form = {
            rucEmisor: values.rucEmisor,
            idTipoComprobante:
              values.idTipoComprobante === undefined
                ? 0
                : values.idTipoComprobante.key,
            serie: values.serie,
            numero: values.numero,
            fechaStr: values.fechaStr.format("DD/MM/YYYY"),
            total: values.total
          };
  
          
          var response = await portalService.xml(form);
          this.setState({
            loading: false,
          });
          if (response !== undefined)
          {
            var nombreFile = form.rucEmisor + "-" + form.serie + "-" + form.numero + ".xml";
            global.dowloadFile(response.data, nombreFile);
          }else {
            message.warning("Verifique los datos del comprobante.");
            return;
          }
       
          if (response.status === 200) {
            message.success("XML descargado correctamente.");
            return;
          }
  
          if (response.status === 400) {
            dialog.warning(
              <ul>
                {response.data.messages.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            );
            return;
          }
  
          dialog.error(
            "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
          );
        }
      });
    });
  };

  handleDescargarPDF = (e) => {
    e.preventDefault();
    this.props.form.setFieldsValue({ validarCorreo: false}, () => {
      // this.props.form.validateFields("correo");
      var recaptchaValue = this.state.recaptchaRef.current.getValue();
      if (recaptchaValue === "") {
        message.error("Confirmación de captcha incorrecta.");
        return;
      }
      this.props.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          this.setState({
            loading: true,
          });
          const form = {
            rucEmisor: values.rucEmisor,
            idTipoComprobante:
              values.idTipoComprobante === undefined
                ? 0
                : values.idTipoComprobante.key,
            serie: values.serie,
            numero: values.numero,
            fechaStr: values.fechaStr.format("DD/MM/YYYY"),
            total: values.total
          };
  
          var response = await portalService.pdfA4(form);
          this.setState({
            loading: false,
          });
  
          if (response !== undefined)
          {
            var nombreFile = form.rucEmisor + "-" + form.serie + "-" + form.numero + ".pdf";
            global.dowloadFile(response.data, nombreFile);
          }else {
            message.warning("Verifique los datos del comprobante.");
            return;
          }
        
          if (response.status === 200) {
            message.success("XML descargado correctamente.");
            return;
          }
  
          if (response.status === 400) {
            dialog.warning(
              <ul>
                {response.data.messages.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            );
            return;
          }
  
          dialog.error(
            "Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde."
          );
        }
      });
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    // getFieldDecorator("validarCorreo", { initialValue: false});
    return (
      <div className="body">
        <Spin tip="Cargando..." size="large" spinning={this.state.loading}>
          <Form>
            <Row type="flex" justify="center">
              <Col sm={20} md={16} lg={14} xl={8}>
                <Row>
                  <Col span={24}>
                    <div className="text-center">
                      <img
                        className="image-portal"
                        src={require("../../assets/images/logo-facturesoft.png")}
                        alt="logo"
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <div className="text-center">
                      <h2>PORTAL FACTURACIÓN ELECTRÓNICA</h2>
                    </div>
                  </Col>
                </Row>
                <Row className="mb-10">
                  <Col span={24}>
                    <div className="text-center">
                      <h3>Consulta de Comprobantes Electrónicos</h3>
                    </div>
                  </Col>
                </Row>

                <Divider />

                <Row>
                  <Col span={24}>
                    <Form.Item label="Ruc del Emisor">
                      {getFieldDecorator("rucEmisor", {
                        initialValue: this.state.web,
                        rules: [
                          {
                            required: true,
                            message: "Campo obligatorio.",
                            whitespace: true,
                          },
                        ],
                      })(
                        <Input
                          maxLength={11}
                          minLength={11}
                          placeholder="Ruc del Emisor"
                          autoComplete="off"
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Form.Item label="Tipo de Comprobante">
                      {getFieldDecorator("idTipoComprobante", {
                        initialValue: this.state.idTipoComprobante
                          ? { key: this.state.idTipoComprobante }
                          : undefined,
                        rules: [
                          {
                            required: true,
                            message: "Campo obligatorio.",
                          },
                        ],
                      })(
                        <Select
                          showSearch
                          labelInValue
                          placeholder={"Seleccione Tipo de Comprobante"}
                          optionFilterProp="children"
                          onChange={this.handleChangeTipoDocumento}
                        >
                          {this.state.tiposComprobante.map((item) => (
                            <Option
                              key={item.id}
                              value={item.id}
                              data={item.id}
                            >
                              {item.nombre}
                            </Option>
                          ))}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item label="Serie">
                      {getFieldDecorator("serie", {
                        initialValue: this.state.web,
                        rules: [
                          {
                            required: true,
                            message: "Campo obligatorio.",
                            whitespace: true,
                          },
                        ],
                      })(
                        <Input
                          placeholder="Serie"
                          maxLength={4}
                          minLength={4}
                          autoComplete="off"
                        />
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Número">
                      {getFieldDecorator("numero", {
                        initialValue: this.state.numero,
                        rules: [
                          {
                            required: true,
                            message: "Campo obligatorio.",
                            whitespace: true,
                          },
                        ],
                      })(
                        <Input
                          placeholder="Número"
                          maxLength={8}
                          autoComplete="off"
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Form.Item label="Fecha">
                      {getFieldDecorator("fechaStr", {
                        initialValue: moment(this.state.fechaStr, "DD/MM/YYYY"),
                        rules: [
                          {
                            type: "object",
                            required: true,
                            message: "Requerido",
                          },
                        ],
                      })(
                        <DatePicker
                          className="first-input"
                          placeholder="Seleccione fecha"
                          prefix={
                            <Icon
                              type="filter"
                              style={{ color: "rgba(0,0,0,.25)" }}
                            />
                          }
                          format="DD/MM/YYYY"
                          onChange={(moment, value) =>
                            this.onChange("fechaStr", value, this.props.form)
                          }
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Form.Item label="Total">
                      {getFieldDecorator("total", {
                        initialValue: this.state.total,
                        rules: [
                          {
                            required: true,
                            pattern: new RegExp(FORMAT_2DECIMALS),
                            message: "Formato decimal incorrecto (0.00)",
                          },
                        ],
                      })(
                        <Input
                          placeholder="Total"
                          autoComplete="off"
                          onBlur={this.complete2Decimals}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <Form.Item label="Correo">
                      {getFieldDecorator("correo", {
                        initialValue: this.state.correo,
                        rules: this.props.form.getFieldValue("validarCorreo") ? [
                          {
                            validator: this.correoCustomValidation,
                          },
                        ] : [],
                      })(<Input placeholder="Correo" autoComplete="off" />)}
                    </Form.Item>

                    {/* <Form.Item label="Correo">
                      {getFieldDecorator("correo", {
                        initialValue: this.state.correo,
                        rules: [
                          {
                            message: "Campo obligatorio.",
                            whitespace: true,
                          },
                        ],
                      })(
                        <Input
                          placeholder="Número"
                          autoComplete="off"
                        />
                      )}
                    </Form.Item> */}
                  </Col>
                </Row>
                <Row type="flex" justify="center" className="mt-10">
                <ReCAPTCHA
                      ref={this.state.recaptchaRef}
                      sitekey="6LfDCVYUAAAAAMXzezGq9UkllGXJjoN25BLF5bXQ"
                    />
                </Row>
              </Col>
            </Row>

            <Row className="mt-15">
              <Col span={24} className="text-center">
                <Button type="primary" className="mr-5" onClick={this.handleDescargarPDF}>
                  Descargar PDF
                </Button>
                <Button type="primary" className="mr-5" onClick={this.handleDescargarXML}>
                  Descargar XML
                </Button>
                <Button type="primary" className="mr-5" onClick={this.handleEnviarCorreo}>
                  Enviar Correo
                </Button>
              </Col>
              {/* <Col span={8} className="text-center">
                <Button type="primary" onClick={this.handleSubmit}>
                  Enviar Correo
                </Button>
              </Col> */}
            </Row>
          </Form>
        </Spin>
      </div>
    );
  }
}

export default Form.create()(Index);
